import {Model} from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";
import { getAging, getFormattedFileSize } from "../../other/utils/utils.jsx";

export class BoardNote extends HasProjectMixin(Model) {
  static get $name() {
    return "boardnote";
  }

  declare isPhantom: boolean;
  declare id: string | number;
  declare name: string;
  declare boardId: number;
  declare resourceId?: number;
  declare clientId?: number;
  declare taskId?: number;
  declare order: number;
  declare canEdit: number;
  declare canView: number;
  declare archived: boolean;
  declare createdAt: string;
  declare updatedAt: string;
  declare updaterId: number;
  declare creatorId: number;

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "boardId", dataSource: "board", type: "integer" },
      { name: "resourceId", dataSource: "resource", type: "integer" },
      { name: "clientId", dataSource: "client", type: "integer" },
      { name: "taskId", dataSource: "task", type: "integer" },
      { name: "order", dataSource: "order", type: "integer" },
      { name: "canEdit", dataSource: "can_edit_grant", type: "integer" },
      { name: "canView", dataSource: "can_view_grant", type: "integer" },
      { name: "archived", dataSource: "archived", type: "boolean" },
      { name: "createdAt", dataSource: "created_at" },
      { name: "updatedAt", dataSource: "updated_at" },
      { name: "updaterId", dataSource: "updater"},
      { name: "creatorId", dataSource: "creator"},
      { name: "size", dataSource: "size_bytes", type: "integer" }
    ]
  }

  get addedBy() {
    return this.creatorName;
  }

  get lastUpdatedAt() {
    return this.updatedAt;
  }

  get lastUpdatedBy() {
    return this.updaterName;
  }

  get size() {
    return this.formatFileSize;
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get creatorName() {
    if (this.project) {
       return this.project.boardUsersStore.getById(this.creatorId)?.name
    }
    return null;
  }

  get updaterName() {
    if (this.project) {
      return this.project.boardUsersStore.getById(this.updaterId)?.name
    }
    return null;
  }

  get noteDetails() {
    const noteRecord = this;
    if (noteRecord) {
      return [noteRecord];
    }
    return [];
  }

  get entity() {
    if (!this.project) return null;
    if (this.resourceId) return this.project.resourceStore.getById(this.resourceId);
    if (this.taskId) return this.project.extraTaskStore.getById(this.taskId);
    if (this.clientId) return this.project.clientsStore.getById(this.clientId);
    return null;
  }

  get formatFileSize() {
    return getFormattedFileSize(this.get("size"));
  }
}

// @ts-expect-error exposeProperties is an internal method
BoardNote.exposeProperties();
